import { render, staticRenderFns } from "./ShopDecoration.vue?vue&type=template&id=882557e8&scoped=true"
import script from "./ShopDecoration.vue?vue&type=script&lang=js"
export * from "./ShopDecoration.vue?vue&type=script&lang=js"
import style0 from "./ShopDecoration.vue?vue&type=style&index=0&id=882557e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882557e8",
  null
  
)

export default component.exports